import ProgressBar from '../atoms/ProgressBar'
import { useSelector } from 'react-redux'

export default function NewCustomersProgressBar() {
  const { isRecastActive } = useSelector((state) => state.recast)

  return (
    <div className="p-4 bg-white rounded-md shadow-md">
      <h4>Closed Lost Opps</h4>
      <ProgressBar barColor="bg-red-500" completePercent={isRecastActive ? 55 : 5} />
    </div>
  )
}
